export default __webpack_public_path__ + "static/media/logo-location-not-allowed.94e9b13b.svg";